import { all, call, put, takeLatest } from 'redux-saga/effects'
import {
    actions,
    getIssuesWithOrdersArticlesSuccess,
    getIssuesWithOrdersArticlesFailed,
    getActiveOrdersArticlesSuccess,
    getActiveOrdersArticlesFailed,
    getPastOrdersIWAOArticlesSuccess,
    getPastOrdersIWAOArticlesFailed,
    getPastOrdersIWDPArticlesSuccess,
    getPastOrdersIWDPArticlesFailed,
    getItemsIssuesListSuccess,
    getItemsIssuesListFailed,
    VoteTheArticleSuccess,
    VoteTheArticleFailed,
    getVotesByArticleSuccess,
    getVotesByArticleFailed,
    getDeliveryIssuesListSuccess,
    getDeliveryIssuesListFailed,
} from './actions'
import {
    getIssueWithOrderArticlesUrl,
    getActiveOrderArticlesUrl,
    getPastOrderIWAOArticlesUrl,
    getPastOrderIWDPArticlesUrl,
    VoteForServiceUrl,
    getItemsIssuesListUrl,
    getVotesUrl,
    getDeliveryIssuesListUrl,
} from './urls'
import { api } from '../../network/api'

function* getActiveOrdersArticlesList() {
    try {
        const response = yield call(api, `${getActiveOrderArticlesUrl}`, 'GET')
        yield put(getActiveOrdersArticlesSuccess(response))
    } catch (error) {
        yield put(getActiveOrdersArticlesFailed())
    }
}
// ============================================================================================================

function* getPastOrdersIWAOArticlesList() {
    try {
        const response = yield call(api, `${getPastOrderIWAOArticlesUrl}`, 'GET')
        yield put(getPastOrdersIWAOArticlesSuccess(response))
    } catch (error) {
        yield put(getPastOrdersIWAOArticlesFailed())
    }
}

function* getPastOrdersIWDPArticlesList() {
    try {
        const response = yield call(api, `${getPastOrderIWDPArticlesUrl}`, 'GET')
        yield put(getPastOrdersIWDPArticlesSuccess(response))
    } catch (error) {
        yield put(getPastOrdersIWDPArticlesFailed())
    }
}

function* getIssuesWithOrdersArticlesList() {
    try {
        const response = yield call(api, `${getIssueWithOrderArticlesUrl}`, 'GET')
        yield put(getIssuesWithOrdersArticlesSuccess(response))
    } catch (error) {
        yield put(getIssuesWithOrdersArticlesFailed())
    }
}

function* VoteTheArticle(action) {
    const request = {
        ...action.payload,
    }
    try {
        const response = yield call(api, `${VoteForServiceUrl}`, 'POST', request)
        yield put(VoteTheArticleSuccess(response))
    } catch (error) {
        yield put(VoteTheArticleFailed())
    }
}

function* getVotesByArticle(action) {
    try {
        const response = yield call(api, `${getVotesUrl}/${action.payload}/votes`, 'GET')
        yield put(getVotesByArticleSuccess(response))
    } catch (error) {
        yield put(getVotesByArticleFailed())
    }
}

function* getItemsIssuesList() {
    try {
        const response = yield call(api, `${getItemsIssuesListUrl}`, 'GET')
        yield put(getItemsIssuesListSuccess(response))
    } catch (error) {
        yield put(getItemsIssuesListFailed())
    }
}

function* getDeliveryIssuesList() {
    try {
        const response = yield call(api, `${getDeliveryIssuesListUrl}`, 'GET')
        yield put(getDeliveryIssuesListSuccess(response))
    } catch (error) {
        yield put(getDeliveryIssuesListFailed())
    }
}

// ============================================================================================================

function* getIssuesWithgOrdersArticlesListWatcher() {
    yield takeLatest(actions.GET_ISSUES_WITH_ORDERS_ARTICLES, getIssuesWithOrdersArticlesList)
}

function* getActiveOrdersArticlesListWatcher() {
    yield takeLatest(actions.GET_ACTIVE_ORDERS_ARTICLES, getActiveOrdersArticlesList)
}
function* getPastOrdersIWAOArticlesListWatcher() {
    yield takeLatest(actions.GET_PAST_ORDERS_IWAO_ARTICLES, getPastOrdersIWAOArticlesList)
}
function* getPastOrdersIWDPArticlesListWatcher() {
    yield takeLatest(actions.GET_PAST_ORDERS_IWDP_ARTICLES, getPastOrdersIWDPArticlesList)
}
function* VoteTheArticleWatcher() {
    yield takeLatest(actions.VOTE_THE_ARTICLE, VoteTheArticle)
}
function* getVotesByArticleWatcher() {
    yield takeLatest(actions.GET_VOTES_BY_ARTICLE, getVotesByArticle)
}
function* getItemsIssuesListWatcher() {
    yield takeLatest(actions.GET_ITEMS_ISSUES_LIST, getItemsIssuesList)
}
function* getDeliveryIssuesListWatcher() {
    yield takeLatest(actions.GET_DELIVERY_ISSUES_LIST, getDeliveryIssuesList)
}
export default function* guides() {
    yield all([
        getIssuesWithgOrdersArticlesListWatcher(),
        getActiveOrdersArticlesListWatcher(),
        getPastOrdersIWAOArticlesListWatcher(),
        getPastOrdersIWDPArticlesListWatcher(),
        VoteTheArticleWatcher(),
        getVotesByArticleWatcher(),
        getItemsIssuesListWatcher(),
        getDeliveryIssuesListWatcher(),
    ])
}
